import { Link } from "react-router-dom";
import { BankInstitutionData } from "../types/bankInstitution";
import { ArrowBigRight } from "lucide-react";
import Button from "../../../common/components/Button";

export class BankingInstitutionTransformer {
  static tableTransformer() {
    return (bankingInstitution: BankInstitutionData[]) => {
      return bankingInstitution.map((bank) => ({
        ...bank,
        display_name: bank?.name,
        actions: (
          <Link to={`/bank-institutions/${bank.id}`} className="cursor-pointer">
            <Button name="access_bank_institution_show" className="w-full" variant="link-white" operationKlassToCheckPermission='Admin::BankInstitutions::Show'>
              <ArrowBigRight />
            </Button>
          </Link>
        )
      }));
    };
  }
}
